import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const audio = {
  createAudio: lazyModuleMethod(() => import('./createAudio'), 'default'),
  fetchAudios: lazyModuleMethod(() => import('./fetchAudios'), 'default'),
  deleteRecord: lazyModuleMethod(() => import('./deleteRecord'), 'default'),
  deleteAudio: lazyModuleMethod(() => import('./deleteAudio'), 'default'),
  fetchAudio: lazyModuleMethod(() => import('./fetchAudio'), 'default'),
  transcribateAudio: lazyModuleMethod(
    () => import('./transcribateAudio'),
    'default'
  ),
  updateAudio: lazyModuleMethod(() => import('./updateAudio'), 'default'),
  updateRecord: lazyModuleMethod(() => import('./updateRecord'), 'default'),
}
